import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  const newsletters = [
    { title: "10 September 2026", url: "/pdfs/IcebergerNewsFINAL10September2026.pdf" },
    { title: "27 August 2026", url: "/pdfs/IcebergerNewsFINAL27August2026.pdf" },
    { title: "13 August 2026", url: "/pdfs/IcebergerNewsFINAL13August2026.pdf" },
    { title: "30 July 2026", url: "/pdfs/IcebergerNewsFINAL30July2026.pdf" },
    { title: "16 July 2026", url: "/pdfs/IcebergerNewsFINAL16July2026.pdf" },
    { title: "2 July 2026", url: "/pdfs/IcebergerNewsFINAL2July2026.pdf" },
    { title: "18 June 2026", url: "/pdfs/IcebergerNewsFINAL18June2026.pdf" },
    { title: "4 June 2026", url: "/pdfs/IcebergerNewsFINAL_4June2026.pdf" },
    { title: "21 May 2026", url: "/pdfs/IcebergerNewsFINAL_21May2026.pdf" },
    { title: "7 May 2026", url: "/pdfs/IcebergerNewsFINAL7May2026.pdf" },
    { title: "23 April 2026", url: "/pdfs/IcebergerNewsFINAL23April2026.pdf" },
    { title: "9 April 2026", url: "/pdfs/IcebergerNewsFINAL9April2026.pdf" },
    { title: "26 Mar 2026", url: "/pdfs/07IcebergerNewsFINAL26March2026.pdf" },
    { title: "12 Mar 2026", url: "/pdfs/06IcebergerNewsFINAL12March2026.pdf" },
    { title: "26 Feb 2026", url: "/pdfs/05IcebergerNewsFINAL26February2026.pdf" },
    { title: "12 Feb 2026", url: "/pdfs/04IcebergerNewsFINAL12February2026.pdf" },
    { title: "29 Jan 2026", url: "/pdfs/03IcebergerNewsletter_FINAL_29January2026.pdf" },
    { title: "15 Jan 2026", url: "/pdfs/02IcebergerNewsFINAL15January2026.pdf" },
    { title: "1 Jan 2026", url: "/pdfs/01IcebergerNewsFINAL1January2026.pdf" },
  ];

  return (
    <div>
      
      <h3>Welcome to the Brighton Icebergers</h3>
      <p>
        Say iceberg and most people will think of a floating ice mass of which
        around only 10 per cent is visible above water. Say ‘Icebergers” in
        Melbourne and most will relate to those of us who swim all year round in
        the bay off Brighton Pier out of the Royal Brighton Yacht Club.
      </p>
      <p>
        The sea temperature at Brighton in Winter is 7–12 deg C rising to 22 deg
        C in summer. But for an Iceberger there are only 3 temperatures; warm,
        cold and #@%! freezing.
      </p>
      <p>Open water, open minds.</p>
      <img src="/images/olsen-hooper_2025.jpg" alt="Olsen and Hooper swim" style={{ width: '80%' }} />

      <h4>Brighton Icebergers @ RBYC</h4>
      <p>253 Esplanade, Middle Brighton, Vic, 3186</p>

      <div className="external-links">
        <a className="external-link-btn" href="https://rbyc.org.au/club/webcam/" target="_blank" rel="noopener noreferrer">Weather / WebCam</a>
        <a className="external-link-btn" href="http://www.baywx.com.au/temps.html" target="_blank" rel="noopener noreferrer">Baywx Temps</a>
        <a className="external-link-btn" href="https://seaswims.club/recentswims?location=Brighton" target="_blank" rel="noopener noreferrer">Swim Temps</a>
      </div>

      <h4 style={{ color: '#d32f2f', marginTop: '30px' }}>⚠️ IMPORTANT - BEFORE YOU SWIM</h4>
      <p style={{ backgroundColor: '#ffe6e6', padding: '15px', borderRadius: '8px', borderLeft: '4px solid #d32f2f' }}>
        <Link to="/blogs/PreSwimPersonalRiskAssessment" style={{ color: '#d32f2f', fontWeight: 'bold', textDecoration: 'none', fontSize: '1.1em' }}>
          Read the Pre-Swim Personal Risk Assessment & Safety Checklist →
        </Link>
      </p>

      <h4>ICEBERGER NEWSLETTERS</h4>
      <p>Click the orange button to read</p>
      <div className="newsletter-grid">
        {newsletters.map((newsletter, index) => {
          // Construct image path: /images/newsletters/FilenameWithoutExt.jpg
          const imageName = newsletter.url.split('/').pop().replace('.pdf', '.jpg');
          const imagePath = `/images/newsletters/${imageName}`;
          
          return (
            <div key={index} className="newsletter-card">
              <div className="pdf-thumbnail-container">
                <img 
                  src={imagePath} 
                  alt={`${newsletter.title} preview`} 
                  onError={(e) => { e.target.src = '/icebergers-logo.gif'; e.target.style.opacity = '0.5'; }}
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </div>
              <a className="external-link-btn" href={newsletter.url} target="_blank" rel="noopener noreferrer">
                {newsletter.title}
              </a>
            </div>
          );
        })}
      </div>

      <h4>ARCHIVED EDITIONS</h4>
      <div className="archive-links">
        <a className="external-link-btn" href="https://drive.google.com/file/d/1TDMgmrhc0cKR48SFQUpQr_5wY0J2CCJD/view?usp=sharing" target="_blank" rel="noopener noreferrer">2025 Editions</a>
        <a className="external-link-btn" href="https://drive.google.com/file/d/12fvP2n2o0aHPuLetrYowGFAehHFLpH9H/view?usp=sharing" target="_blank" rel="noopener noreferrer">2024 Editions</a>
        <a className="external-link-btn" href="https://drive.google.com/file/d/1pruY4-5B16VAJ9NaEIAMP14BTaUdzYpD/view?usp=sharing" target="_blank" rel="noopener noreferrer">2023 Editions</a>
        <a className="external-link-btn" href="https://drive.google.com/file/d/1qAyG4Qsuxt0OAgN8W7HSkrcPx8co2WiO/view?usp=sharing" target="_blank" rel="noopener noreferrer">2022 Editions</a>
        <a className="external-link-btn" href="https://drive.google.com/file/d/1yW3ljb91Q2O0eYn2y8gyZvj559dxA3fF/view?usp=sharing" target="_blank" rel="noopener noreferrer">2021 Editions</a>
        <a className="external-link-btn" href="https://epublications.snap.com.au/ebook/10049444/html/index.html" target="_blank" rel="noopener noreferrer">2020 Editions</a>
      </div>

      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default Home;